// Slide-out cart: renders /cart.js into snippets/cart-drawer.liquid.
// Opens on the 'cart:item-added' event (fired by the product page) and on header cart link clicks.
(function () {
  const drawer = document.getElementById('CartDrawer');
  const configElement = document.getElementById('CartDrawerConfig');
  if (!drawer || !configElement) return;

  const config = JSON.parse(configElement.textContent);
  const upsellProducts = config.upsell.filter(Boolean);
  const itemsList = drawer.querySelector('[data-cart-drawer-items]');
  const emptyMessage = drawer.querySelector('[data-cart-drawer-empty]');
  const totalElement = drawer.querySelector('[data-cart-drawer-total]');
  const checkoutButton = drawer.querySelector('[data-cart-drawer-checkout]');
  const shippingBlock = drawer.querySelector('[data-cart-drawer-shipping]');
  const upsellBlock = drawer.querySelector('[data-cart-drawer-upsell]');
  let lastFocused = null;

  function formatMoney(pence) {
    return config.currencySymbol + (pence / 100).toFixed(2);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function fetchCart() {
    return fetch(config.routes.cartJs, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  function changeQuantity(key, quantity) {
    return fetch(config.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then((r) => r.json());
  }

  function addVariant(variantId) {
    return fetch(config.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    }).then((r) => r.json());
  }

  function render(cart) {
    document.querySelectorAll('#CartCount').forEach((el) => { el.textContent = cart.item_count; });

    itemsList.innerHTML = cart.items.map((item) => `
      <li class="cart-drawer__item">
        <a href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(sizedImage(item.image, 160))}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}</a>
        <div>
          <p class="cart-drawer__item-title"><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></p>
          ${item.product_has_only_default_variant ? '' : `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>`}
          <div class="cart-drawer__qty">
            <button type="button" data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
            <span>${item.quantity}</span>
            <button type="button" data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="cart-drawer__remove" data-key="${escapeHtml(item.key)}" data-quantity="0">Remove</button>
        </div>
        <span class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</span>
      </li>`).join('');

    const isEmpty = cart.item_count === 0;
    emptyMessage.hidden = !isEmpty;
    checkoutButton.hidden = isEmpty;
    totalElement.textContent = formatMoney(cart.total_price);

    renderShipping(cart);
    renderUpsell(cart);
  }

  function renderShipping(cart) {
    if (!config.freeShippingPence || cart.item_count === 0) {
      shippingBlock.hidden = true;
      return;
    }
    const remaining = config.freeShippingPence - cart.total_price;
    shippingBlock.hidden = false;
    shippingBlock.querySelector('.cart-drawer__shipping-text').textContent = remaining > 0
      ? `You're ${formatMoney(remaining)} away from free UK shipping.`
      : 'You qualify for free UK shipping.';
    const percent = Math.min(100, Math.round((cart.total_price / config.freeShippingPence) * 100));
    shippingBlock.querySelector('.cart-drawer__shipping-bar span').style.width = percent + '%';
  }

  function renderUpsell(cart) {
    const productIdsInCart = new Set(cart.items.map((item) => item.product_id));
    const suggestions = upsellProducts.filter((p) => !productIdsInCart.has(p.productId)).slice(0, 2);
    if (cart.item_count === 0 || suggestions.length === 0) {
      upsellBlock.hidden = true;
      return;
    }
    upsellBlock.hidden = false;
    upsellBlock.querySelector('.cart-drawer__upsell-list').innerHTML = suggestions.map((p) => `
      <li class="cart-drawer__upsell-item">
        <a href="${escapeHtml(p.url)}">${p.image ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}</a>
        <div><a href="${escapeHtml(p.url)}">${escapeHtml(p.title)}</a><p>${formatMoney(p.price)}</p></div>
        ${p.singleVariant
          ? `<button type="button" class="cart-drawer__upsell-add" data-variant-id="${p.variantId}">Add</button>`
          : `<a class="cart-drawer__upsell-add" href="${escapeHtml(p.url)}">View</a>`}
      </li>`).join('');
  }

  function refresh() {
    return fetchCart().then(render);
  }

  function open() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('cart-drawer-open');
    drawer.querySelector('.cart-drawer__close').focus();
    return refresh();
  }

  function close() {
    drawer.hidden = true;
    document.body.classList.remove('cart-drawer-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-close]')) {
      close();
      return;
    }
    const quantityButton = event.target.closest('button[data-key]');
    if (quantityButton) {
      quantityButton.disabled = true;
      changeQuantity(quantityButton.dataset.key, Number(quantityButton.dataset.quantity)).then(render);
      return;
    }
    const addButton = event.target.closest('button[data-variant-id]');
    if (addButton) {
      addButton.disabled = true;
      addVariant(addButton.dataset.variantId).then(refresh);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });

  document.addEventListener('cart:item-added', open);

  // Header "Cart (n)" link opens the drawer instead of navigating; the cart page itself still works.
  document.addEventListener('click', (event) => {
    const cartLink = event.target.closest('a[href="' + config.routes.cart + '"]');
    if (!cartLink || drawer.contains(cartLink) || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    open();
  });

  window.CartDrawer = { open, close, refresh };
})();
